(() => {
  const init = () => document.querySelectorAll('[data-tpl-image-dialog]').forEach(dialog => {
    if (dialog.dataset.viewerReady) return;
    dialog.dataset.viewerReady = 'true';
    const scope = dialog.closest('.tpl-pdp') || dialog.parentElement;
    const links = [...scope.querySelectorAll('[data-tpl-image-enlarge]')];
    const photoKey = link => new URL(link.href).pathname;
    const groupKey = link => {
      if (scope.querySelector('[data-tpl-moccasin-approved-photo]')) {
        return link.closest('.tpl-editorial-product__hero,.tpl-editorial-product__images') ? 'moccasin-product' : 'moccasin-context';
      }
      if (!scope.classList.contains('tpl-pdp--tee')) return 'all';
      if (link.closest('.tpl-tee-flat,.tpl-tee-gallery')) return 'retail';
      if (link.closest('.tpl-product-making')) return 'making';
      if (link.closest('.tpl-tee-styling')) return 'styling';
      return photoKey(link);
    };
    const photosFor = group => [...new Map(links.filter(link => group === null || groupKey(link) === group).map(link => [photoKey(link), {key:photoKey(link), url:link.href, alt:link.querySelector('img')?.alt || ''}])).values()];
    let photos = photosFor(null);
    if (!photos.length) return;
    const stage = dialog.querySelector('[data-tpl-image-stage]');
    const image = dialog.querySelector('[data-tpl-image-full]');
    const count = dialog.querySelector('[data-tpl-image-count]');
    const reset = dialog.querySelector('[data-tpl-image-reset]');
    const previous = dialog.querySelector('[data-tpl-image-previous]');
    const next = dialog.querySelector('[data-tpl-image-next]');
    const more = dialog.querySelector('[data-tpl-image-more]');
    const less = dialog.querySelector('[data-tpl-image-less]');
    const close = dialog.querySelector('[data-tpl-image-close]');
    const points = new Map();
    let index = 0, scale = 1, x = 0, y = 0, opener, start, pinch, lastTap = 0;
    const clamp = (v,low,high) => Math.max(low,Math.min(high,v));
    const draw = () => {
      const rect = stage.getBoundingClientRect();
      x = clamp(x,-rect.width*(scale-1)/2,rect.width*(scale-1)/2);
      y = clamp(y,-rect.height*(scale-1)/2,rect.height*(scale-1)/2);
      image.style.transform = `translate(${x}px,${y}px) scale(${scale})`;
      stage.classList.toggle('is-zoomed',scale>1);
      reset.textContent = `${Math.round(scale*100)}%`;
      more.disabled = scale >= 3; less.disabled = scale <= 1;
    };
    const zoom = value => { scale = clamp(value,1,3); if (scale === 1) x=y=0; draw(); };
    const show = value => {
      index = clamp(value,0,photos.length-1); scale=1; x=y=0; points.clear(); pinch=null;
      stage.classList.add('is-loading');
      image.alt=photos[index].alt; image.src=photos[index].url;
      count.textContent=`${String(index+1).padStart(2,'0')} / ${String(photos.length).padStart(2,'0')}`;
      previous.disabled=index===0; next.disabled=index===photos.length-1; draw();
    };
    image.addEventListener('load',()=>stage.classList.remove('is-loading'));
    image.addEventListener('error',()=>stage.classList.remove('is-loading'));
    const dismiss = (restore=true) => { if (!dialog.open) return; dialog.close();points.clear();pinch=null;if(restore)opener?.focus({preventScroll:true}); };
    links.forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();opener=link;photos=photosFor(groupKey(link));show(photos.findIndex(p=>p.key===photoKey(link)));
      if(!dialog.open)dialog.show();draw();close.focus({preventScroll:true});
    }));
    close.addEventListener('click',()=>dismiss());
    previous.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
    more.addEventListener('click',()=>zoom(scale+.5));less.addEventListener('click',()=>zoom(scale-.5));reset.addEventListener('click',()=>zoom(1));
    const keyboard = event => {
      if (!dialog.open || event.target.closest('input,textarea,select')) return;
      if (event.key==='Escape') {event.preventDefault();dismiss();}
      else if (dialog.contains(event.target)) {
        if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}
        if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}
        if(event.key==='+'||event.key==='='){event.preventDefault();zoom(scale+.5);}
        if(event.key==='-'){event.preventDefault();zoom(scale-.5);}
        if(event.key==='0'){event.preventDefault();zoom(1);}
      }
    };
    document.addEventListener('keydown',keyboard);
    stage.addEventListener('wheel',event=>{event.preventDefault();zoom(scale-event.deltaY*.004);},{passive:false});
    const distance = () => {const [a,b]=[...points.values()];return Math.hypot(a.x-b.x,a.y-b.y);};
    stage.addEventListener('pointerdown',event=>{
      if(event.button!==0)return;event.stopPropagation();stage.setPointerCapture(event.pointerId);
      points.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(points.size===1){start={x:event.clientX,y:event.clientY,baseX:x,baseY:y,time:performance.now(),moved:false};}
      if(points.size===2){pinch={distance:distance(),scale};start.moved=true;}
      stage.classList.add('is-dragging');
    });
    stage.addEventListener('pointermove',event=>{
      if(!points.has(event.pointerId))return;event.stopPropagation();points.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(points.size===2&&pinch){zoom(pinch.scale*distance()/Math.max(1,pinch.distance));return;}
      if(!start||pinch)return;
      const dx=event.clientX-start.x,dy=event.clientY-start.y;if(Math.hypot(dx,dy)>8)start.moved=true;
      if(scale>1){x=start.baseX+dx;y=start.baseY+dy;draw();}
    });
    const end = event => {
      if(!points.has(event.pointerId))return;event.stopPropagation();
      const wasPinch=!!pinch;points.delete(event.pointerId);
      if(points.size)return;
      stage.classList.remove('is-dragging');pinch=null;
      if(event.type==='pointercancel'||wasPinch){start=null;return;}
      if(start){
        const dx=event.clientX-start.x,dy=event.clientY-start.y;
        if(scale===1&&Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.4){show(index+(dx<0?1:-1));}
        else if(!start.moved){
          const now=performance.now();
          if(event.pointerType==='mouse'||now-lastTap<320){zoom(scale>1?1:2);lastTap=0;}else lastTap=now;
        }
      }
      start=null;
    };
    stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
    // Choosing Add, Pay, or a purchase service returns immediately to the product.
    const purchase = scope.querySelector('.tpl-purchase-bar');
    const purchaseAction = event => {if(event.target.closest('button,a'))dismiss(false);};
    purchase?.addEventListener('click',purchaseAction,true);
    const resize = new ResizeObserver(()=>{if(dialog.open)draw();});resize.observe(stage);
    const unload = event => {if(event.target.contains(dialog)){resize.disconnect();document.removeEventListener('keydown',keyboard);purchase?.removeEventListener('click',purchaseAction,true);document.removeEventListener('shopify:section:unload',unload);}};
    document.addEventListener('shopify:section:unload',unload);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

